/* create rootEpic by combining all the epics of our project. 
For this, we will use the combineEpic function redux-observable.*/

import { combineEpics } from "redux-observable";

export const rootEpic = combineEpics();
//allEpic,
